export default "__VITE_ASSET__CoCV55Xn__"